import { Toast } from 'antd-mobile';
import { achorRankInfo, achorRankList } from '@/services/activity';
import { followUser } from '@/services/api';
export default {
  namespace: 'achorRank',
  state: {
    activityId: '',
    title: '',
    titleUrl: '',
    activityStatus: null,
    endTime: 0,
    rules: '',
    firstTab: [],
    secondTab: [],
    limitedGift: [],
    dateList: [],
    userRankVos: [],
    personalRankVo: {},
    rewards: [],
    pageNum: 1,
    pageSize: 20,
    isMore: false,
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        activityId: payload.activityId || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        activityStatus: payload.activityStatus || 0,
        endTime: payload.endTime || 0,
        rules: payload.rules || '',
        firstTab: payload.firstTab || [],
        secondTab: payload.secondTab || [],
        limitedGift: payload.limitedGift || [],
        dateList: payload.dateList || [],
        rewards: payload.rewards || [],
      };
    },
    updateRankList(state, { payload }) {
      let newList = payload.force ? [] : [...state.userRankVos];
      if (payload.userRankVos && payload.userRankVos.length) {
        newList = [...newList, ...payload.userRankVos];
      }
      return {
        ...state,
        userRankVos: newList,
        personalRankVo: payload.personalRankVo || {},
        pageNum: payload.pageNum,
        isMore: newList.length < payload.total,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(achorRankInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *toFollow({ payload }, { call }) {
      const { error } = yield call(followUser, payload);
      if (error) {
        Toast.show({
          content: error,
        });
        return false;
      }
      return true;
    },
    *getRankList({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.achorRank);
      const { error, data } = yield call(achorRankList, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateRankList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force },
      });
      return true;
    },
  },
};
